import template from "./index.html";
import "./index.less";

export function controller($logger, clipboard) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.canClipboard = clipboard.supported;
	};
}

// type ExportMetadata = {
// 	Value: string;
// 	Type: {
// 		Code: string;
// 		Name: string;
// 		Participant: {
// 			Code: Guid;
// 			Name: string;
// 		}
// 	}
// };

export const metadataTab = angular.module("vesl.components.exports.view-export.metadata-tab", [])
	.component("metadataTab", {
		controller,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
